var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-disallowed-to-change-plan"},[_c('return-to-plan-list-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }